import { render, staticRenderFns } from "./Blurb.vue?vue&type=template&id=40cc3b42&scoped=true&"
import script from "./Blurb.vue?vue&type=script&lang=ts&"
export * from "./Blurb.vue?vue&type=script&lang=ts&"
import style0 from "./Blurb.vue?vue&type=style&index=0&id=40cc3b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cc3b42",
  null
  
)

export default component.exports